import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { FILTER_VARIANT_API } from "./apiRoutes";

interface UseGetFilterVariantsProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getFilterVariantsById = async (id: string) =>
  await axiosAuth.get(`${FILTER_VARIANT_API}/${id}`);

const useGetFilterVariantsById = ({
  queryParams,
  id,
}: UseGetFilterVariantsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["managerial-filter-variance", id],
    queryFn: () => getFilterVariantsById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!id && (queryParams?.enabled ?? true),
  });
};

export default useGetFilterVariantsById;
